export const LOGIN = 'LOGIN';
export const LOGIN_RESET = 'LOGIN_RESET';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_TYPES = [
  LOGIN,
  LOGIN_SUCCESS,
  LOGIN_ERROR
];


// WEBPACK FOOTER //
// ./src/core/services/login/action-types.js